import React from 'react';
import { Controller, FieldPath, FieldValues } from 'react-hook-form';
import { StyledQuestionFieldContainer } from '../Questionnaires/QuestionnairePage/components/QuestionViewerEditor/QuestionEditor/styles';
import { ErrorMessage } from '../Services/styled-components';
import { InputProps } from './types';
import Switch from '../Shared/Switch';

interface SwitchEditorProps<TFieldValues extends FieldValues, TName extends FieldPath<TFieldValues>>
  extends InputProps<TFieldValues, TName> {
  label: string;
}

function SwitchEditor<TFieldValues extends FieldValues, TName extends FieldPath<TFieldValues>>({
  control,
  name,
  label,
}: SwitchEditorProps<TFieldValues, TName>) {
  return (
    <Controller
      control={control}
      name={name}
      render={({ field, fieldState }) => (
        <StyledQuestionFieldContainer>
          <Switch
            checked={field.value}
            onChange={field.onChange}
            label={label}
            disabled={false}
            value={field.value}
            reverseOrder={false}
          />
          <ErrorMessage>{fieldState.error?.message}</ErrorMessage>
        </StyledQuestionFieldContainer>
      )}
    />
  );
}

export default SwitchEditor;
